import { render, staticRenderFns } from "./RandomText.vue?vue&type=template&id=4ae8fc21"
import script from "./RandomText.vue?vue&type=script&lang=js"
export * from "./RandomText.vue?vue&type=script&lang=js"
import style0 from "./RandomText.vue?vue&type=style&index=0&id=4ae8fc21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports